const getters = {
    smPartners: state => state.sm_partners,
    smPartner: state => state.sm_partner,
    smPartnerTypes: state => state.sm_partner_types,
    smPartnerLegalForms: state => state.sm_partner_legal_forms
}

export default getters;
